export const getPageNumberForPaginationItem = ({
	page,
	type,
	disabled,
}: {
	page: number;
	type: 'page' | 'first' | 'last' | 'next' | 'previous' | 'start-ellipsis' | 'end-ellipsis';
	disabled: boolean;
}) => {
	if (type === 'previous' && disabled) {
		return page + 1;
	} else if (type === 'next' && disabled) {
		return page - 1;
	} else {
		return page;
	}
};